import { useState } from "react";
import {
  getProcurementActionLabel,
  getProcurementActionsForStatus,
} from "./procurementOrderActionConfig";

export default function ProcurementOrderReviewPanel({ status, onSubmit, loading = false }) {
  const [note, setNote] = useState("");
  const allowedActions = getProcurementActionsForStatus(status).filter((action) =>
    ["review", "approve", "reject"].includes(action)
  );

  if (allowedActions.length === 0) return null;

  const submit = (action) => {
    onSubmit?.(action, note);
  };

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4">
      <h3 className="text-sm font-semibold text-slate-900">Review panel</h3>
      <p className="mt-1 text-xs text-slate-500">Voorbereiding op uitgebreidere approval-flow en TU/factuurcontrole.</p>
      <textarea
        value={note}
        onChange={(e) => setNote(e.target.value)}
        rows={2}
        placeholder="Interne reviewnotitie (optioneel)"
        className="mt-3 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm"
      />
      <div className="mt-3 flex flex-wrap gap-2">
        {allowedActions.map((actionKey) => (
          <button
            key={actionKey}
            type="button"
            disabled={loading}
            onClick={() => submit(actionKey)}
            className={
              actionKey === "reject"
                ? "rounded-lg border border-rose-200 bg-rose-50 px-3 py-1.5 text-xs text-rose-700 disabled:opacity-60"
                : "rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs text-slate-700 disabled:opacity-60"
            }
          >
            {getProcurementActionLabel(actionKey)}
          </button>
        ))}
      </div>
    </div>
  );
}
